import {
  Component, NgModule, OnDestroy, OnInit, EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild
} from '@angular/core';
import { DemoService } from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router } from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { ngf, ngfModule } from 'angular-file';

import { DatePipe } from '@angular/common'; 
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { BehaviorSubject, Observable, Subject, map, Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { SystemFile } from './../../../shared/models/systemFile.model';
import { Job } from './../../../shared/models/job.model';
import { Permission } from './../../../shared/models/permission.model';
import { SystemLog } from './../../../shared/models/sysLog.model';
import { DataUtil } from '@syncfusion/ej2-data';
import { ReactiveFormsModule } from '@angular/forms';

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic"
import { BrowserModule } from '@angular/platform-browser'


import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';


@Component({
  selector: 'app-jobs-file-attached-widget',
  templateUrl: './jobs-file-attached-widget.component.html',
  styleUrls: ['./jobs-file-attached-widget.component.scss']
})
export class JobsFileAttachedWidgetComponent implements OnInit {

  // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?  // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?;
  @Input() show_buttons?= 'no'; // yes | no
  @Input() widget_title?= 'File Uploads';
  @Input() widget_size?; // side | abstract | full | attempt

  @Input() subject_id?: any;
  @Input() file_number?: any; // subject file number
  @Input() subject_number?: any; // subject file number
  @Input() brand_type_id?: number; // subject file number
  @Input() reference_number?: any; // subject file number
  
  @Input() subject_service_id?: any; // subject file number
  @Input() service_file_array?: any; // subject file number


  @Input() job_id: any;
  model: any; // File upload permissions model.
  job: any;
  file_model: SystemFile;


  //  :: file uploader Variables
  // map the result through the model
  create_file: SystemFile;
  //create_files: File[];
  create_sys_log: SystemLog;
  permission_model: Permission;

  @Input() attach_file_array_name?: any; // name of the array if automatically attaching file for attempts
  data: any;
  modalRef: BsModalRef;
  // ote, data


  // @Output('RemoveElementFromAllAttach') RemoveElementFromAllAttach: EventEmitter<any> = new EventEmitter();
  @Output('RemoveElementFromAllRecipients_Parent') RemoveElementFromAllRecipients_Parent: EventEmitter<any> = new EventEmitter();

  

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
  ) { }




  ngOnChanges(changes) {
    if (changes.item_data) {
      // deal with asynchronous Observable result
      this.item_data = changes.item_data.currentValue;
      // this.item_data = JSON.stringify(this.item_data); // test for update attempt compontent 
      
      // this.job = new Job();
      // this.permission_model = new Permission();
      // this.file_model = new SystemFile();
      // this.getJob(this.job_id);
    }
  }

  ngOnInit(): void {
    this.item_data = this.item_data;
  }



 // MODAL
// start of modal windows service as a template
// openModal(template: TemplateRef<any>) {
//   // small upgrade to disable background click on open modal background
//   // small upgrade to disable background click on open modal background
//   const config = { backdrop: false, ignoreBackdropClick: true, class: 'gray modal-lg' };
//   this.modalRef = this.modalService.show(template, config);
// }

openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
 }
 

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
this.gfunc.globalJobViewSkipRoute(this.job_id);
};


// uses this for attempts removal of files in array
RemoveElementFromAllAttach(key: number, attach_file_array_name) {

      // now run the parent to remove from the global array - attemps allRecipeints in the master or bleow component
      this.RemoveElementFromAllRecipients_Parent.emit(key);  

  this.item_data.forEach((value, index) => {
    if (value.file_name === key) {
      this.item_data.splice(index, 1);
    }

  });

 
//   // removes all property_sign_images
//   if(attach_file_array_name == 'property_sign_images'){

// }

//   // removes all propety_images
//   if(attach_file_array_name == 'property_images'){
//   this.model.property_images.forEach((value, index) => {
//     if (value.file_name === key) {
//       this.model.property_images.splice(index, 1);
//     }
//   });
// }


        // removes all attachments - general to the attempt
        // this.allAttachments.forEach((value, index) => {
        //   if (value.file_name === key) {
        //     this.allAttachments.splice(index, 1);
        //   }
        // });
}






}
